// Librerías
import React from "react";
import ReactGA from "react-ga4";
import { isMobile } from "react-device-detect";
// Componentes
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import SearchPagePaginate from "../components/SearchPage/SearchPagePaginate";

ReactGA.initialize("G-SXE6FS3SVC");

const SearchPage = (props) => {
  return (
    <React.Fragment>
      <Navbar addSearch={true} />
      <SearchPagePaginate />
      {!isMobile && <Footer />}
    </React.Fragment>
  );
};

export default SearchPage;
